<template>
    <div class="mx-3">
        <archive-information-modal @save="updateArchiveNote"></archive-information-modal>        
        <!-- <claim-list-filters-modal></claim-list-filters-modal> -->
        <div v-if="clients.length === 1" class="h4">
            {{ clientName }}
        </div>        
        <div v-else class="dropdown h4">
            <a id="clientDropdown" class="dropdown-toggle" href="#" role="button" data-toggle="dropdown">
                {{ clientName }}
            </a>
            <div class="dropdown-menu dropdown-menu-right">
                <button :key="'client-dropdown-menu-item-0'" class="h5 dropdown-item" @click="onClientClick(0)">All Clients</button>
                <button v-for="client in clients" :key="'client-dropdown-menu-item-' + client.id" class="h5 dropdown-item" @click="onClientClick(client.id)">{{ client.name }}</button>
            </div>
        </div>        
        <div class="d-flex justify-content-between align-items-end">
            <h2 class="text-muted font-italic text-center">Archived Claims</h2>
            <div class="btn-toolbar mb-2" role="toolbar">
                <div v-if="state.searchOption" class="input-group mr-2">
                    <div class="input-group-prepend">
                        <button class="btn dropdown-toggle input-group-text" type="button" data-toggle="dropdown">{{ state.searchOption.name }}</button>
                        <div class="dropdown-menu">
                            <button v-for="searchOption in searchOptions" :key="'search-option-' + searchOption.id" class="dropdown-item text-primary" @click="state.searchOption = searchOption">{{ searchOption.name }}</button>
                        </div>
                    </div>                    
                    <input ref="searchInput" type="text" class="form-control" :placeholder="state.searchOption.placeholder" v-model="state.searchString">
                    <div class="input-group-append">
                        <button class="btn btn-primary" @click="search()"><i class="fas fa-search fa-lg"></i></button>
                    </div>                    
                </div>                    
                <div class="btn-group">
                    <!-- <a href="#" class="btn btn-primary" data-toggle="tooltip" title="Filters" @click="showFilters()">
                        <i class="fas fa-filter fa-lg"></i>                   
                    </a>                                        -->
                    <a href="/claims" class="btn btn-primary" data-toggle="tooltip" title="Active Claim List">
                        <i class="fas fa-list fa-lg"></i>
                    </a>
                </div>            
            </div>
        </div>

        <div v-if="claims.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th></th>
                        <th>Claim Number</th>
                        <th>Patient Name</th> 
                        <th>Date of Birth</th>
                        <th>Payer</th>
                        <th v-if="state.clientId == 0">Client</th>
                        <th>Provider</th>
                        <th>Archived</th>
                        <th></th>
                    </tr>                    
                </thead>
                <tbody>
                    <template v-for="claim in claims">
                        <tr :key="'achived-claim-list-' + claim.id">
                            <td class="fit">
                                <i v-if="claim.status === 'Attention'" class="fas fa-exclamation-triangle fa-lg text-warning" :title="claim.status"></i>
                                <i v-else class="fas fa-fw fa-lg"></i>
                                <i v-if="claim.shared" class="fas fa-balance-scale fa-sm text-muted pb-1" title="Shared with Attorney"></i>
                            </td>
                            <td>{{ claim.claim_number }}</td>
                            <td>{{ claim.patient_name }}</td>
                            <td>{{ claim.patient_dob }}</td>
                            <td :title="claim.payer_name">{{ claim.payer_name }}</td>
                            <td v-if="state.clientId == 0" :title="claim.client_name">{{ claim.client_name }}</td>
                            <td :title="claim.provider_name">{{ claim.provider_name }}</td>
                            <td>{{ claim.archived_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>                    
                            <td>
                                <div class="d-flex flex-nowrap flex-row justify-content-end">

                                    <div class="text-center">
                                        <button class="btn btn-link p-0 m-0" title="Archive Information" @click="showInfo(claim)">
                                            <i class="fas fa-info-circle fa-lg fa-fw"></i>
                                        </button>                                    
                                    </div>                                    

                                    <div class="text-center">
                                        <button class="btn btn-link btn-sm py-0 px-1" title="Unarchive Claim" @click="unarchive(claim.id)">
                                            <div class="fa-stack">
                                                <i class="fas fa-archive fa-stack-1x"></i>
                                                <i class="fas fa-arrow-circle-up fa-stack-1x fa-inverse archive-icon"></i>
                                            </div> 
                                        </button>
                                    </div>

                                </div>                                
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <div class="d-flex">
                <nav v-if="pageCount > 1" aria-label="Page navigation">
                    <ul class="pagination">
                        <li v-bind:class="['page-item', { 'disabled' : state.currentPage == 1 }]">
                            <a class="page-link" href="#" @click="first()">
                                <span id="first-page"><i class="fas fa-step-backward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                        <li v-bind:class="['page-item', { 'disabled' : state.currentPage == 1 }]">
                            <a class="page-link" href="#" @click="previous()">
                                <span id="previous"><i class="fas fa-chevron-left fa-xs chev-pos"></i><i class="fas fa-chevron-left fa-xs mr-1 chev-pos"></i>Previous</span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : state.currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="next()">
                                <span id="next">Next<i class="fas fa-chevron-right fa-xs ml-2 chev-pos"></i><i class="fas fa-chevron-right fa-xs chev-pos"></i></span>
                            </a>
                        </li>
                        <li v-bind:class="['page-item', { 'disabled' : state.currentPage == pageCount }]">
                            <a class="page-link" href="#" @click="last()">
                                <span id="first-page"><i class="fas fa-step-forward fa-xs chev-pos"></i></span>
                            </a>
                        </li>                        
                    </ul>
                </nav>
                <div class="ml-auto"> Page {{ state.currentPage }} of {{ pageCount }}</div>
            </div>
        </div>
        <div v-else-if="isLoading" class="pt-3 border-top">            
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>
        <div v-else class="pt-3 border-top">
            <h2 class="text-muted text-center">No archived claims.</h2>
        </div>     
    </div>
</template>

<script>
import ArchiveInformationModal from '../ArchiveInformationComponent.vue';
// import ClaimListFiltersModal from './ClaimListFiltersComponent.vue';

export default {
    components: {
        ArchiveInformationModal
        // ClaimListFiltersModal
    },
    props: {
        clients: Array,
        selectedClientId: Number,
        searchOptions: Array,
        selectedSearchOptionId: Number,
        searchText: String,
        page: Number
    },
    data() {
        return {
            state: {
                clientId: this.selectedClientId,
                searchString: this.searchText,
                currentPage: this.page,
                searchOption: this.searchOptions.find(x => x.id === this.selectedSearchOptionId)
            },
            pageCount: 0,
            claims: [],
            isLoading: true,
            channels: []
        }
    },
    computed: {
        clientName: function () {
            return this.state.clientId ? this.clients.find(x => x.id == this.state.clientId).name : 'All Clients';
        }
    },
    methods: {
        refresh: function () {
            this.isLoading = true;
            let href = this.state.clientId ? '/ajax/clients/' + this.state.clientId + '/claims' : '/ajax/claims';
            axios.get(href, {
                params: {
                    'archived_claims': true,
                    'search_option_id': this.state.searchOption.id,
                    'search_string': this.state.searchString,
                    'page': this.state.currentPage - 1
                }
            })
            .then(response => {
                this.claims = response.data.claims;
                this.pageCount = response.data.page_count;
                this.isLoading = false;
            })
            .catch(error => {
                console.log('got an error...');
                this.isLoading = false;
            });
        },
        search: function () {
            this.state.currentPage = 1;
            this.refresh();
        }, 
        onClientClick: function (id) {
            this.state.clientId = id;
            this.state.currentPage = 1;
            this.refresh();
            this.listen();       
        },
        first: function () {
            if (this.state.currentPage > 1) {
                this.state.currentPage = 1;
                this.refresh();
            }
        },        
        previous: function() {
            if (this.state.currentPage > 0) {
                this.state.currentPage--;
                this.refresh();
            }
        },
        next: function() {
            if (this.state.currentPage < this.pageCount) {
                this.state.currentPage++;
                this.refresh();
            }
        },
        last: function () {
            if (this.state.currentPage < this.pageCount) {
                this.state.currentPage = this.pageCount;
                this.refresh();
            }
        },        
        setChannelNames: function () {

            // clear the array
            this.channels = [];        

            if (this.state.clientId == 0) {

                // create a channel for each client
                var self = this;
                this.clients.forEach(element => {
                    self.channels.push('claim-event.' + element.id);
                });
            }
            else if (this.state.clientId > 0) {

                // create a channel for the selected client
                this.channels.push('claim-event.' + this.state.clientId);
            }
        },
        listen: function () {

            var self = this;

            // leave all channels
            self.channels.forEach(channel => {
                window.Echo.leave(channel);
            });          
            
            // reset the channel names base on the selected client
            self.setChannelNames();               

            // listen on all required channels
            self.channels.forEach(channel => {

                // if we get a claim event update the list
                window.Echo.private(channel).listen('ClaimEvent', (e) => {
                    self.refresh();
                });
            });       
        },
        showInfo: function (claim) {
            eventHub.$emit('show-archive-information', claim);
        },        
        unarchive: function (id) {
            axios.patch('/ajax/claims/' + id + '/unarchive')
                .then(response => {
                    // nothing to do; event will update ui 
                })
                .catch(error => {
                    toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
                });
        },
        updateArchiveNote: function (claim) {

            axios.patch(`/ajax/claims/${claim.id}/archive/note`, {
                note: claim.archive_note
            })
            .then(response => {
                
            })
            .catch(error => {
                toastr['error'](error.response.data.message, 'Error', { timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true });
            });
        }
        // showFilters: function () {
        //     eventHub.$emit('show-claim-filters');
        // }
    },
    created() {

        this.refresh();
        this.listen();
    },
    beforeDestroy() {

        // leave all channels
        this.channels.forEach(channel => {
            window.Echo.leave(channel);
        });
    },
    mounted() {        
        this.$refs.searchInput.setAttribute('size', this.$refs.searchInput.getAttribute('placeholder').length);
    }
}
</script>

<style scoped>
    .archive-icon {
        padding-top: 3px;
        font-size: .85em;
    }

::-webkit-input-placeholder {
   font-style: italic;
}
:-moz-placeholder {
   font-style: italic;  
}
::-moz-placeholder {
   font-style: italic;  
}
:-ms-input-placeholder {  
   font-style: italic; 
}    
</style>